import SocialMedia from './SocialMedia.vue';
import SocialMediaList from './views/socialMediaList.vue';

export const socialMediaRoutes = [
  {
    path: 'socialMedia',
    component: SocialMedia,
    children: [
      { path: '', component: SocialMediaList, name: 'socialList' }
    ]
  }
];
